// src/utils/DecryptData.js
// 1  ───────────────────────────────────────────────────────────────────────
// 2  // Exports:
// 3  //   - customEncode(str)           -> your custom encode algorithm
// 4  //   - setCredentials(user, pass)  -> set runtime credentials (optional)
// 5  //   - getAuthHeader()             -> returns "Encrypted <base64>"
// 6  //   - authFetch(url, options)     -> wrapper around fetch that adds Authorization header
// 7  //   - getCredentials()            -> returns current credentials (for debugging)
// 8  //  Use authFetch() in place of fetch() to automatically include your encoded header.
// 9  // ───────────────────────────────────────────────────────────────────────

// 10 // Default credentials (change if you want to hardcode; better to call setCredentials at runtime)
export let USERNAME = "buyforcash";
export let PASSWORD = "1137";

// 12 // customEncode: exact implementation you provided
export function customEncode(str) {
  let encoded = "";
  if (str != null) {
    for (let i = 0; i < str.length; i++) {
      let asc = str.charCodeAt(i);
      let c = str[i];

      if (asc === 1) c = String.fromCharCode(asc + 228);
      else if (asc === 32) c = String.fromCharCode(asc + 196);
      else if (asc >= 33 && asc < 65) c = String.fromCharCode(asc + 90);
      else if (asc >= 65 && asc < 75) c = String.fromCharCode(asc + 92);
      else if (asc >= 75 && asc < 85) c = String.fromCharCode(asc + 94);
      else if (asc >= 85 && asc < 97) c = String.fromCharCode(asc + 96);
      else if (asc >= 97 && asc < 107) c = String.fromCharCode(asc + 98);
      else if (asc >= 107 && asc < 117) c = String.fromCharCode(asc + 100);
      else if (asc >= 117 && asc < 126) c = String.fromCharCode(asc + 102);
      // otherwise leave c unchanged
      encoded += c;
    }
  }
  return encoded;
}

// 38 // base64 helper: use browser btoa when possible, but provide UTF-8-safe fallback
function base64EncodeSafe(str) {
  try {
    // btoa expects binary string (Latin1); our mapped chars are likely within that range.
    return btoa(str);
  } catch (err) {
    // fallback for Unicode content
    // encodeURIComponent -> bytes -> unescape -> btoa
    return btoa(unescape(encodeURIComponent(str)));
  }
}

// 51 // setCredentials: update credentials at runtime (safer than hardcoding)
export function setCredentials(user, pass) {
  USERNAME = user;
  PASSWORD = pass;
}

// 56 // getCredentials: returns the current credentials (useful for debugging only)
export function getCredentials() {
  return { USERNAME, PASSWORD };
}

// 61 // encodeCredentials: apply customEncode and base64 wrap, returns the base64 string (no prefix)
export function encodeCredentials(username = USERNAME, password = PASSWORD) {
  const creds = `${username}:${password}`;
  const customEncoded = customEncode(creds);
  const safeHeader = base64EncodeSafe(customEncoded);
  return safeHeader;
}

// 69 // getAuthHeader: returns the full header value string: "Encrypted <base64>"
export function getAuthHeader(username = USERNAME, password = PASSWORD) {
  const base64 = encodeCredentials(username, password);
  return `Encrypted ${base64}`;
}

// 75 // authFetch: wrapper around fetch that injects Authorization header and default JSON content-type
// 76 // Usage: authFetch(url, { method: "POST", body: JSON.stringify(payload) })
export async function authFetch(url, options = {}) {
  // Ensure options is an object
  options = options || {};

  // Build headers object (case-insensitive)
  const headers = new Headers(options.headers || {});

  // Add Content-Type default if not present and body exists
  if (!headers.has("Content-Type") && options.body != null) {
    headers.set("Content-Type", "application/json");
  }

  // Add Authorization header
  headers.set("Authorization", getAuthHeader());

  // Build final options
  const finalOptions = {
    ...options,
    headers,
  };

  // Debug: uncomment to log headers (do not leave in prod)
  // console.log("authFetch headers:", Array.from(headers.entries()));

  const response = await fetch(url, finalOptions);

  // Optionally, handle non-OK statuses centrally (here we just return response and let caller handle)
  return response;
}

// 105 // default export (optional): gives convenient single import
export default {
  customEncode,
  setCredentials,
  getCredentials,
  encodeCredentials,
  getAuthHeader,
  authFetch,
};
